import { z } from 'zod';
/**
 * Zod sin `eval`, para la PWA (P-114).
 *
 * Zod 4 compila el parseo de los objetos con `new Function` cuando el entorno lo
 * permite, y para saberlo **prueba** una vez un `new Function("")` adentro de un
 * `try`. La CSP de la PWA no tiene `unsafe-eval` (D-295): la prueba falla como
 * corresponde, Zod sigue por el camino sin compilar, y el navegador igual
 * registra una violación de `script-src` en cada carga. Era P-114: el `eval`
 * atribuido al bundle principal que no aparecía en el código (estaba en
 * `zod/v4/core/util.js`, `allowsEval`).
 *
 * Con `jitless`, Zod no prueba y va directo por el camino sin compilar, que es
 * el que la PWA ya usaba. La api no lo llama: no corre bajo una CSP y le sirve el
 * camino compilado.
 *
 * **Tiene que correr antes de que se construya cualquier esquema**, no sólo
 * antes de parsear: Zod decide el camino al crear cada objeto. Por eso vive en
 * su propia entrada, `@pasos/schemas/sin-eval`, que importa Zod y nada más; si
 * estuviera en el índice, importarla construiría todos los esquemas del paquete
 * antes de apagar la prueba.
 */
export function zodSinEval() {
    z.config({ jitless: true });
}
//# sourceMappingURL=sin-eval.js.map